import { render } from "./UploadDisplayImage.vue?vue&type=template&id=2bcfb4ea&scoped=true"
import script from "./UploadDisplayImage.vue?vue&type=script&lang=js"
export * from "./UploadDisplayImage.vue?vue&type=script&lang=js"

import "./UploadDisplayImage.vue?vue&type=style&index=0&id=2bcfb4ea&scoped=true&lang=css"

import exportComponent from "/Users/ofmartinez/WebDev/orbeas/Holton-OrbeasRogue-Web-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcfb4ea"]])

export default __exports__